import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'
import {
  CreateTimesheetOvertimeRequestMutationVariables,
  TimesheetOvertimeRequestFragment,
} from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import { useFormContext } from 'modules/core/hooks/useForm'
import { formatSecondsToHM } from 'modules/core/lib/formatTime'
import i18n from 'modules/core/lib/i18n'

import { STATUS } from 'modules/attendance/lib/enums'

interface Props {
  onClose: () => void
  loading: boolean
  canApprove: boolean
  overtimeRequest?: TimesheetOvertimeRequestFragment | null
}

const ModalFooter = ({ onClose, loading, canApprove, overtimeRequest }: Props) => {
  const form = useFormContext<CreateTimesheetOvertimeRequestMutationVariables>()
  const dateHasNotPendingRequest = overtimeRequest && overtimeRequest.status !== STATUS.pending
  const dateHasPendingRequest = overtimeRequest && overtimeRequest.status === STATUS.pending

  const addVerb = canApprove
    ? i18n.t('time_tracking.modals.overtime_request.add')
    : i18n.t('time_tracking.modals.overtime_request.request')

  const submitButton = dateHasPendingRequest
    ? i18n.t('time_tracking.modals.overtime_request.update_request')
    : `${i18n.t('time_tracking.modals.overtime_request.duration_request', {
        verb: addVerb,
        duration: formatSecondsToHM((form.values.hoursAmount || 0) * 3600),
      })}`

  return (
    <>
      <Button type="secondary" onClick={onClose}>
        {i18n.t('common.cancel')}
      </Button>
      <Button
        disabled={(loading || dateHasNotPendingRequest) ?? false}
        onClick={() => form.handleSubmit()}
      >
        {submitButton}
      </Button>
    </>
  )
}

export default observer(ModalFooter)
